import { UserTaskRole } from 'common/types';
import { ROUTER_PATHNAME } from './routes';

// 路由路径定义
export { ROUTER_PATHNAME };

export const joinPathnameAndSearchParams = (pathname: string, params?: { [key in string]: string }): string => {
  let searchParams = '';

  // 如果params里包含activeTab，那么就要把activeTab的值拼接到pathname后面
  if (params?.activeTab) {
    pathname = `${pathname}/${params.activeTab}`;
    delete params.activeTab;
  }
  Object.entries(params || {}).forEach(([key, value], index) => {
    searchParams += `${index === 0 ? '' : '&'}${key}=${value}`;
  });

  return `/${pathname}${searchParams ? `?${searchParams}` : ''}`;
};
const joinMySalesSearchParams = (pathname: string, params?: { [key in string]: string }): string => {
  let searchParams = '';

  Object.entries(params || {}).forEach(([key, value], index) => {
    searchParams += `${index === 0 ? '' : '&'}${key}=${value}`;
  });

  return `/${pathname}${searchParams ? `?${searchParams}` : ''}`;
};

export enum TaskRouterSubpath {
  ExternalContacts = 'external-contacts', // 制作
  InternalContacts = 'internal-contacts', // 审核
  Allocator = 'allocator', // 需求方（发包）
}

export enum RedirectParams {
  PublishTask = 'publishTask', // 跳转到发布任务
  Recharge = 'recharge', // 跳转到充值
  BindAlipay = 'bindAlipay', // 跳转到绑定支付宝
  BindBankcard = 'bindBankcard', // 跳转到绑定银行卡
  Withdraw = 'withdraw', // 跳转到提现
  UploadAsset = 'uploadAsset', // 跳转到上传资产
  biddingTasksMarket = 'bidding-tasks-market',
  ArtistAuth = 'artist-auth', // 跳转到创作者认证
  Task = 'task',
  ArtistHome = 'artist-home',
  MySales = 'my-sales',
}

export const MyInfoRouterParams = {
  activeTab: {
    security: 'security', // 基础信息
    realNameAuth: 'realNameAuth', // 身份认证
    artistAuth: 'artistAuth', // 创作者认证
    paymentSetting: 'paymentSetting', //支付设置
    userProtocol: 'userProtocol', // 协议信息
    qualification: 'qualification', // 资质认证
    messageSetting: 'messageSetting',
    withdrawList: 'withdrawList', // 提现记录
  },
  realNameAuth: {
    true: 'true', // 是否实名认证
  },
  enterpriseAuth: {
    true: 'true', // 是否企业认证
  },
  redirect: {
    [RedirectParams.PublishTask]: RedirectParams.PublishTask, // 跳转到发布任务
    [RedirectParams.UploadAsset]: RedirectParams.UploadAsset, // 跳转到上传资产
    [RedirectParams.Recharge]: RedirectParams.Recharge, // 跳转到充值
    [RedirectParams.BindAlipay]: RedirectParams.BindAlipay, // 跳转到绑定支付宝
    [RedirectParams.BindBankcard]: RedirectParams.BindBankcard, // 跳转到绑定银行卡
    [RedirectParams.Withdraw]: RedirectParams.Withdraw, // 跳转到提现
    [RedirectParams.biddingTasksMarket]: RedirectParams.biddingTasksMarket, // 跳转到任务市场
    [RedirectParams.ArtistAuth]: RedirectParams.ArtistAuth, // 跳转到创作者认证
    [RedirectParams.MySales]: RedirectParams.MySales, // 跳转到任务
  },
} as const;

// type RouterSearchParams<T> =

export const navToMyInfo = (
  params: { [key in keyof typeof MyInfoRouterParams]?: keyof (typeof MyInfoRouterParams)[key] } = {},
): string => {
  return joinPathnameAndSearchParams(ROUTER_PATHNAME.USER_PREFERENCE, params);
};

export const MySalesRouterParams = {
  activeTab: {
    rechargeList: 'rechargeList', // 充值记录
    withdrawList: 'withdrawList', // 提现记录
    balanceList: 'balanceList', // 余额支付记录
    scoreList: 'scoreList', // 积分交易记录
  },
  recharge: {
    true: 'true', // 打开充值页面
  },
  withdraw: {
    true: 'true', // 打开提现页面
  },
} as const;

export const navToMySales = (
  params: { [key in keyof typeof MySalesRouterParams]?: keyof (typeof MySalesRouterParams)[key] } = {},
): string => {
  return joinMySalesSearchParams(ROUTER_PATHNAME.MY_SALES, params);
};

export const subPathRoleMap: { [key in TaskRouterSubpath]: UserTaskRole } = {
  [TaskRouterSubpath.ExternalContacts]: UserTaskRole.ExternalContacts,
  [TaskRouterSubpath.Allocator]: UserTaskRole.Allocator,
  [TaskRouterSubpath.InternalContacts]: UserTaskRole.InternalContacts,
};
